<template>
  <div ref="references" :class="poppverWrapClasses">
    <div ref="defaulButton" :class="poppverTriggerClasses">
      <t-button v-if="poptipBtnShow">{{ poptipText }}</t-button>
      <slot v-else></slot>
    </div>

    <transition name="fade">
      <t-popper
        ref="poptip"
        v-detach="popperJS"
        :visiable.sync="model"
        :transition-name="transitionName"
        :title="title"
        :content="content"
        :confirm="confirm"
        :confirm-text="confirmText"
        :cancel-text="cancelText"
        :show-title="showTitle"
        :show-content="showContent"
        :width="width"
        v-on="$listeners"
      >
        <slot slot="title" name="title"></slot>
        <slot slot="content" name="content"></slot>
      </t-popper>
    </transition>
  </div>
</template>
<script>
import TPopper from './popper.vue'
import Popper from 'popper.js'
import locale from '@/mixins/locale'
import Detach from '../../directives/detacher'

import { PREFIX_CLASS } from '@/utils/constants'
const PREFIXCLS = `${PREFIX_CLASS}popover`
export default {
  name: 'TPoptip',
  components: {
    TPopper
  },
  directives: {
    Detach
  },
  mixins: [locale],
  props: {
    /** 标识弹出框位置 */
    placement: {
      type: String,
      default: 'top-end',
      validator: (value) => {
        /* [
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'left',
          'left-start',
          'left-end',
          'right',
          'right-start',
          'right-end'
        ] */
        return Popper.placements.includes(value)
      }
    },
    /** 触发弹出框显示与否的事件 */
    trigger: {
      type: String,
      default: 'click',
      validator(value) {
        return ['click', 'focus', 'hover'].includes(value)
      }
    },
    /** 弹出框标题
     * { 不写则为空 }
     */
    title: {
      type: [String, Number],
      default: ''
    },
    /** 弹出框显示的内容
     *{ 内容可以为text、html }
    */
    content: {
      type: [String, Number],
      default: ''
    },
    /** 弹出框自定义宽度 */
    width: {
      type: [String, Number],
      default: ''
    },
    /** 弹出框下方的确认与取消按钮是否显示 */
    confirm: {
      type: Boolean,
      default: false
    },
    /** 若未自定义弹出框的触发元素使用默认元素，可在此设置默认元素内容 */
    poptipText: {
      type: String,
      default: '按钮'
    },
    /** 若confirm=true,本属性用于自定义取消按钮的显示内容 */
    cancelText: {
      type: String,
      default: '取消'
    },
    /** 若confirm=true,本属性用于自定义确认按钮的显示内容 */
    confirmText: {
      type: String,
      default: '确认'
    },
    /** 弹出框动态效果 */
    transitionName: {
      type: String,
      default: 'fade'
    },
    /** 若设置，弹出框现实与否均由外部控制 */
    value: {
      type: Boolean,
      default: undefined
    },
    options: {
      type: Object,
      default () {
        return {
          gpuAcceleration: false,
          boundariesElement: 'viewport',
          forceAbsolute: true
        }
      }
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      popperJS: null,
      poptipShow: false,
      showContent: false,
      showTitle: false,
      currentTarget: ''
    }
  },
  computed: {
    poptipBtnShow() {
      return !(this.$slots.default && this.$slots.default[0].tag)
    },
    poppverWrapClasses() {
      return `${PREFIXCLS}-wrap`
    },
    poppverTriggerClasses() {
      return `${PREFIXCLS}-trigger`
    },
    model: {
      get() {
        let getValue
        if (this.value !== undefined) {
          getValue = this.value
        } else {
          getValue = this.poptipShow
        }
        return getValue
      },
      set(value) {
        if (this.value !== undefined) {
          this.poptipShow = this.value
        } else {
          this.poptipShow = value
        }
        this.$emit('onVisibleChange', this.poptipShow)
        this.$_updatePosition()
      }
    }
  },
  watch: {
    poptipShow(val) {
      this.model = val
    },
    value(val) {
      this.model = val
    }
  },
  created() {
    this.showTitle = this.$slots.title !== undefined || !!this.title
    this.showContent = this.$slots.content !== undefined || !!this.content
  },
  mounted() {
    this.$_placement()
    if (this.value !== undefined) return
    let vm = this
    let parentNode = this.$refs.references
    document.addEventListener('click', function(e) {
      vm.currentTarget = e.target
      if (parentNode.contains(e.target)) return
      vm.poptipShow = false
    }, false)

    if (vm.trigger === 'click') {
      this.$refs.defaulButton.addEventListener(vm.trigger, vm.$_poptipBtn, false)
    } else if (vm.trigger === 'hover') {
      this.$refs.references.addEventListener('mouseenter', vm.$_openBtn, false)
      this.$refs.references.addEventListener('mouseleave', vm.$_closeBtn, false)
    } else if (vm.trigger === 'focus') {
      this.$refs.defaulButton.addEventListener('focus', vm.$_openBtn, true)
      this.$refs.defaulButton.addEventListener('blur', vm.$_closeBtn, true)
    }
  },
  beforeDestroy() {
    this.popperJS.destroy()
    this.popperJS = null
  },
  methods: {
    /** 点击 */
    $_poptipBtn(e) {
      if (this.poptipShow) {
        this.$_closeBtn()
      } else {
        this.$_openBtn(e)
      }
    },
    /** 打开弹框 */
    $_openBtn(event) {
      event.preventDefault()
      this.poptipShow = true
      this.$_updatePosition()
    },
    /** 关闭弹框 */
    $_closeBtn() {
      if (this.trigger === 'focus' && (!!this.$refs.references.contains(this.currentTarget))) return
      this.poptipShow = false
      this.$_updatePosition()
    },
    $_placement() {
      const options = this.options
      const isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1
      const boundariesElement = isIE10 === true ? 'body' : 'viewport'
      options.placement = this.placement
      options.modifiers = {
        preventOverflow: {
          boundariesElement: boundariesElement
        },
        computeStyle: {
          gpuAcceleration: false
        }
      }
      this.popperJS = new Popper(this.$refs.defaulButton, this.$refs.poptip.getPopNode, options)
      this.popperJS.update()
      this.popperJS.disableEventListeners()
    },
    $_updatePosition() {
      this.$nextTick(() => {
        this.popperJS.update()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/poptip/reference.vue